import React, {useMemo, memo} from 'react';
import {connect} from 'react-redux';
import {CircularProgressbar} from 'react-circular-progressbar';
import {easeQuadInOut} from 'd3-ease';
import ProgressProvider from '../../CellcomAbroadLobbyBlock/PackageExists/ProgressProvider';
import FamilyPackageUsageDetailsPopUp from '../FamilyPackageUsageDetailsPopUp/FamilyPackageUsageDetailsPopUp';
import {useFamilyBundleUsage, familyBundleMapState} from '../hooks/useFamilyBundleUsage';

const CircleContainer = memo(({outOfTotal, unit, children}) => (
  <div className='all-circle-container'>
    <div className='quantity-and-unit-line'>
      <span className='calls'>גלישה</span>
      <span className='vertical-line'></span>
      <span className='unit-and-quantity'>
        {outOfTotal}
        {unit}
      </span>
    </div>
    <div className='circle-container'>
      <div className='circle-children'>{children}</div>
    </div>
  </div>
));

const SVG_STYLE = {width: '100%', height: '100%'};

const GRADIENTS = (
  <defs>
    <linearGradient id='gradientAbove75' x1='0.23' y1='0.77' x2='0.77' y2='0.23'>
      <stop offset='4%' stopColor='#e74141' />
      <stop offset='129%' stopColor='var(--theme-primary, #810ea9)' />
    </linearGradient>
    <linearGradient id='gradientBelow75' x1='0.36' y1='0.64' x2='0.64' y2='0.36'>
      <stop offset='11%' stopColor='var(--theme-primary, #810ea9)' />
      <stop offset='76%' stopColor='var(--theme-bright,#c5a0ef)' />
    </linearGradient>
  </defs>
);

const CircularProgressBar = memo(
  ({usage: usageProp, unit, outOfTotal, SocData = {}, costumerMobile, familyBundleMemberUsageData, familyBundleCollectiveUsageData}) => {
    const {
      isSubscriberHasFamilyBundleUsageData,
      isFamilyBundleManager,
      packageKey,
      popupPackageUsages,
      popupCollectiveUsages,
      subLabel: bottomLabel,
      familyPackageUsagePopup,
      openPopup,
      closePopup,
    } = useFamilyBundleUsage({
      SocData: {...SocData, expirationDate: SocData?.endDate || ''},
      costumerMobile,
      familyBundleMemberUsageData,
      familyBundleCollectiveUsageData,
    });

    const topLabel = isSubscriberHasFamilyBundleUsageData ? 'ניצול משותף' : 'ניצלת';

    const usage = useMemo(() => {
      const toUsageStr = (val) => {
        const num = Number(val);
        if (num > 0 && num < 0.5) return '1';
        if (num >= 99 && num < 100) return '99';
        return Math.round(num).toString();
      };
      if (!isSubscriberHasFamilyBundleUsageData) return toUsageStr(usageProp);
      const rawUsageData = isFamilyBundleManager ? popupCollectiveUsages : popupPackageUsages;
      return toUsageStr(rawUsageData?.[packageKey]?.[0]?.used_pct || 0);
    }, [usageProp, SocData, popupCollectiveUsages, popupPackageUsages]);

    const gradientId = Number(usage) >= 75 ? 'gradientAbove75' : 'gradientBelow75';

    const circleBarStyles = useMemo(() => ({
      path: {stroke: `url(#${gradientId})`},
    }), [gradientId]);

    return (
      <>
        <CircleContainer outOfTotal={outOfTotal} unit={unit}>
          <div className={`top-label ${bottomLabel ? 'with-bottom-label' : ''}`}>{topLabel}</div>
          <ProgressProvider valueStart={0} valueEnd={usage} easingFunction={easeQuadInOut} duration={1.4}>
            {(usage) => (
              <svg style={SVG_STYLE}>
                {GRADIENTS}
                <CircularProgressbar strokeWidth={6} value={usage} text={`${Math.round(usage)}%`} styles={circleBarStyles} className={bottomLabel ? 'with-bottom-label' : ''} />
              </svg>
            )}
          </ProgressProvider>
          {bottomLabel && (
            <div className='circle-bottom-label' onClick={openPopup}>
              {bottomLabel}
            </div>
          )}
        </CircleContainer>
        <FamilyPackageUsageDetailsPopUp
          showPopUp={familyPackageUsagePopup}
          onClose={closePopup}
          packageUsages={popupPackageUsages}
          collectiveUsages={popupCollectiveUsages}
        />
      </>
    );
  },
);

const mapDispatchToProps = {};

export default connect(familyBundleMapState, mapDispatchToProps)(CircularProgressBar);
